/** Normalize empty date filters so queries share cache with the dashboard. */
export function normalizeReportDateFilters(from: string, to: string) {
  const fromVal = from || undefined;
  const toVal = to || undefined;
  if (!fromVal && !toVal) return undefined;
  return { from: fromVal, to: toVal };
}

/** True while a report section has no data yet (initial load or new filter key). */
export function isReportSectionLoading(
  isPending: boolean,
  isFetching: boolean,
  data: unknown,
) {
  return isPending || (isFetching && data === undefined);
}
